import { useUrl } from "lib/site";
import LanguageEdit from "screens/components/LanguageEdit";

function PbaasAppLanguageCreate() {
    const returnUrl = useUrl()("PbaasAppLanguages");
    return <LanguageEdit returnUrl={returnUrl}/>;
}

export default PbaasAppLanguageCreate